import { FinancialAdvisorAvailabilityUpdateDTO } from "../dto.ts";
import { AppointmentFiltersDTO, AppointmentResponseDTO, AppointmentsCreateDTO, AppointmentsDTO, AppointmentsUpdateRequestDTO, UpdateStatusRequest } from "./dto.ts";
import { AppointmentsServiceImpl } from "./serviceImpl.ts";

export interface AppointmentsService {
    updateAvailabilitesFinancialAdvisor(id: string, request: FinancialAdvisorAvailabilityUpdateDTO): Promise<void>
    appointmentsCreate(request: AppointmentsCreateDTO): Promise<void>
    findAllAppointments(filters: AppointmentFiltersDTO): Promise<AppointmentResponseDTO>
    appointmentsDelete(id: string): Promise<void>
    findByIdAppointment(id: string): Promise<AppointmentsDTO>
    rescheduleAppointment(id: string, request: AppointmentsUpdateRequestDTO): Promise<void>
    updateStatusAppointment(id: string, request: UpdateStatusRequest): Promise<void>
}

export function NewAppointmentsService(): AppointmentsService {
    return new AppointmentsServiceImpl();
}
